module.exports = __webpack_public_path__ + "static/media/notes.68938371.svg";